import React, { createContext, useState, useContext } from "react";
import { SubscribeExternalModuleReactAPI } from "@coreapp/main";

const RecordInfoContext = createContext();

const RecordInfoProvider = ({ children }) => {
  const [showRecordInfo, setShowRecordInfo] = useState(false);
  const [selectedBox, setSelectedBox] = useState(null);
  const [showSourceInfo, setShowSourceInfo] = useState(false);

  const openRecordInfo = selectedBox => {
    setSelectedBox(selectedBox);
    setShowRecordInfo(true);
    setShowSourceInfo(false);
  };

  const closeRecordInfo = () => {
    setShowRecordInfo(false);
  };

  const openSourceInfo = selectedBox => {
    setSelectedBox(selectedBox);
    setShowSourceInfo(true);
    setShowRecordInfo(false);
  };

  const closeSourceInfo = () => {
    setShowSourceInfo(false);
  };

  const context = {
    openRecordInfo,
    closeRecordInfo,
    openSourceInfo,
    closeSourceInfo,
    selectedBox,
    showRecordInfo,
    showSourceInfo
  };

  // Effect to register the provider to core app
  React.useEffect(() => {
    SubscribeExternalModuleReactAPI(context, "recordInfo");
  }, []);

  return <RecordInfoContext.Provider value={context}>{children}</RecordInfoContext.Provider>;
};

export const useRecordInfoContext = () => useContext(RecordInfoContext);

export default RecordInfoProvider;
